"use strict";
/*
 * Created on 03 19 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");

var Family_1 = require("../Family");
/**
 * Encapsulates result of creation of new {@link Family family}. User can change {@link Product product's family} within this process,
 * thus this object encapsulates not only created family, but also all other families, that could be potentially changed during the
 * process. All changed products can be loaded based on this result.
 *
 * @author JMe
 */


var FamilyCreatedDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(FamilyCreatedDTO, _DomainObject_1$Domai);

  /**
   * @param family the created family
   * @param affectedFamilies the list of all affected families, empty if there was no affected family
   */
  function FamilyCreatedDTO(family, affectedFamilies) {
    var _this;

    _classCallCheck(this, FamilyCreatedDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FamilyCreatedDTO).call(this));
    _this.family = family;
    _this.affectedFamilies = affectedFamilies;
    return _this;
  }

  return FamilyCreatedDTO;
}(DomainObject_1.DomainObject);

exports.FamilyCreatedDTO = FamilyCreatedDTO;

FamilyCreatedDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(FamilyCreatedDTO.name);
  return {
    family: builder.obj('family', Family_1.Family.schema, function (mat) {
      return Family_1.Family.fromDataDict(mat);
    }),
    affectedFamilies: builder.listOf(builder.obj('affectedFamilies', Family_1.Family.schema, function (mat) {
      return Family_1.Family.fromDataDict(mat);
    }))
  };
}();